import { render, staticRenderFns } from "./IconDatepicker.vue?vue&type=template&id=d0c6922c&"
import script from "./IconDatepicker.vue?vue&type=script&lang=js&"
export * from "./IconDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports